import { getShares } from '../api/cloudShare';
import { getPlaylistCovers } from '../digitalVault';
import { dispatch } from 'oasis-os-react';
import { fetchCache, getCacheKey, persistCache } from '../utils';
const parseResources = (resources) => {
    return resources.map((resource) => {
        resource.nodeId = resource.uid;
        resource.uri = resource.location;
        return resource;
    });
};
const dispatchAndCovers = (resources) => {
    const playlists = resources?.length &&
        resources?.filter((item) => {
            return item.type === 'playlist';
        });
    if (playlists.length > 0) {
        getPlaylistCovers(playlists, 'getShareResources');
        dispatch('*', 'headerToolbarFiles', playlists);
    }
    const filesAndFolders = resources?.length &&
        resources?.filter((item) => {
            return item.type === 'file' || item.type === 'folder';
        });
    if (filesAndFolders.length > 0) {
        dispatch('*', 'headerToolbarFiles', filesAndFolders);
    }
};
const getShareResourcesApi = async (shareId, count, cursor, cacheProps, logger, fetchPlaylistCovers) => {
    const urlParams = new URLSearchParams([['count', count.toString()]]);
    cursor && urlParams.append('cursor', cursor);
    const { resources, links } = await getShares(`/${shareId}/resources?${urlParams.toString()}`, {}, logger);
    const next = links?.find((item) => item.rel === 'next')?.href || false;
    let nextPage = '';
    if (next) {
        const params = new URL(next);
        nextPage = params.searchParams.get('cursor');
    }
    if (resources?.length) {
        const parsedResources = parseResources(resources);
        let params = { count };
        cursor && (params = { ...params, cursor });
        const key = getCacheKey({
            params,
            endpoint: `${cacheProps?.cacheKeyPrefix}-${shareId}/resources`,
        });
        const value = { url: key, data: { links }, parsedResources };
        fetchPlaylistCovers && dispatchAndCovers(resources);
        if (cacheProps?.updateCache) {
            await persistCache('share_resources', key, value);
        }
        return {
            data: parsedResources,
            hasNextPage: !!nextPage,
            paginate() {
                return !!nextPage && getShareResources(shareId, count, nextPage, cacheProps, logger);
            },
        };
    }
    return {
        hasNextPage: false,
        data: [],
        paginate() {
            return null;
        },
    };
};
const getShareResources = async (shareId, count, cursor, cacheProps, logger, fetchPlaylistCovers = true) => {
    if (cacheProps?.readFromCache) {
        let params = { count };
        cursor && (params = { ...params, cursor });
        const key = getCacheKey({
            params,
            endpoint: `${cacheProps?.cacheKeyPrefix}-${shareId}/resources`,
        });
        const cacheResp = await fetchCache('share_resources', key);
        if (cacheResp) {
            const next = cacheResp.data.links?.find((item) => item.rel === 'next')?.href || false;
            let nextPage = '';
            if (next) {
                const params = new URL(next);
                nextPage = params.searchParams.get('cursor');
            }
            fetchPlaylistCovers && dispatchAndCovers(cacheResp.parsedResources);
            return {
                data: cacheResp.parsedResources,
                hasNextPage: !!nextPage,
                paginate() {
                    return !!nextPage && getShareResources(shareId, count, nextPage, cacheProps, logger);
                },
            };
        }
    }
    return getShareResourcesApi(shareId, count, cursor, cacheProps, logger, fetchPlaylistCovers);
};
export default getShareResources;
